export default __webpack_public_path__ + "static/media/twittericon.2d0673d4.png";